import { render, staticRenderFns } from "./profile-kyc.vue?vue&type=template&id=40edd328&"
import script from "./profile-kyc.vue?vue&type=script&lang=js&"
export * from "./profile-kyc.vue?vue&type=script&lang=js&"
import style0 from "./profile-kyc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports